module.exports = __webpack_public_path__ + "img/pattern_9.60225410.png";